exports = module.exports = require("../../../../../../legacy/web-builder/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".classificationMainView{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}._2Wd54q0Wf9YF0w7vGyHpQO{overflow-y:auto}\n", ""]);

// exports
exports.locals = {
	"instructionsInfo": "_2Wd54q0Wf9YF0w7vGyHpQO"
};